import React, { useEffect } from 'react'
import { Modal as RModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { VariableCategory } from './VariableCategory';
import { Form } from '../../../../components/general/general-component/abstruct-component/AbstructForm';
import { AbstructVar } from '../../../../components/general/general-component/abstruct-component/AbstructVar';
import { AbstructLang } from '../../../../components/general/general-component/abstruct-component/AbstructLang';
import { putCategory } from '../../../../store/Actions/ActionCategory';

function EditCategory({ arr, open, setOpen }) {
    const { mode, dispatch, navigate, langLocal } = AbstructVar();
    const { translate } = AbstructLang();
    const { state, setStateCustom, setLoad, setState } = VariableCategory();
    useEffect(() => {
        setState((prevState) => ({
            ...prevState,
            name: arr.name,
            description: arr.description,
        }));
    }, [arr]);

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(putCategory(arr.id, state.name, state.description, setLoad));
    };
    const formFields = [
        { name: 'name', label: 'name', type: 'text', inputType: 'text', iconType: "pencil" },
        { name: 'description', label: 'description', type: 'text', inputType: 'text', iconType: "pencil" },
    ];

    return (
        <RModal
            open={open}
            onClose={() => {
                setOpen(false);
            }}
            center
            classNames={{
                modal: 'popupR',
            }}
            focusTrapped={false}
            overlayOpacity={0.5}
        >
            <div className={`div_popup ${mode === 'dark' ? 'darkPopUp' : 'lightPopUp'}`}>
                <div className={`div_title_popup ${mode === 'dark' ? 'darktoppopup' : 'lighttoppopup'}`}>
                    <p className={`title_popup ${mode === 'dark' ? 'darktext' : 'lighttext'}`}>{translate('edit_category')}</p>
                </div>
                <Form langLocal={langLocal} fields={formFields} handleSubmit={handleSubmit} state={state} setStateCustom={setStateCustom} translate={translate} buttonLabel="edit" />
            </div>
        </RModal>
    );
}

export default EditCategory;

